export default "/packs/images/true-adventure-large~48e9ec44b7bfd41b98465602c13ef47a.png";